import { render } from "./SelectMealGame.vue?vue&type=template&id=717618fb&scoped=true"
import script from "./SelectMealGame.vue?vue&type=script&lang=js"
export * from "./SelectMealGame.vue?vue&type=script&lang=js"

import "./SelectMealGame.vue?vue&type=style&index=0&id=717618fb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-717618fb"]])

export default __exports__